import FrameComment from './frame-comment';
import InlineComment from './inline-comment';
import CommentModal from './comment-modal';

export default class CommentManager {
    constructor(editor, onUpdate) {
        this.editor = editor;
        this.onUpdate = onUpdate;
        this.comments = [];

        editor.on('zoomed', () => {
            this.comments.map(c => c.blur.call(c));
        });
    }

    addInlineComment(text, [ x, y ], links = []) {

        if (!text) {
            new CommentModal({
                comment: {
                    name: text
                },
                isInlineComment: true,
                onSave: ({ name, color }) => new Promise((resolve) => {
                    let comment = new InlineComment(name, this.editor, color);

                    comment.k = () => this.editor.view.area.transform.k;
                    comment.x = x;
                    comment.y = y;
                    comment.linkTo(links);
            
                    this.addComment(comment);
                    // this.onUpdate();
                    this.editor.trigger('commentupdated', true);
                    resolve(true);
                })
            });
        }
    }

    addFrameComment(pName, [ x, y ], links = [], width = 0, height = 0, pColor) {

        let createComment = ({ name, color }) => {
            let comment = new FrameComment(name, this.editor, color);
            
            comment.x = x;
            comment.y = y;
            comment.width = width;
            comment.height = height;
            comment.linkTo(links);
            
            this.addComment(comment);
        }

        if (!pName) {
            new CommentModal({
                comment: {
                    color: pColor,
                    name: pName
                },
                isInlineComment: false,
                onSave: (values) => new Promise((resolve) => {
                    createComment(values);
                    // this.onUpdate();
                    this.editor.trigger('commentupdated', true);
                    resolve(true);
                })
            });
        } else {
            createComment({name: pName, color: pColor});
        }
    }

    addComment(comment) {
        comment.update();
        this.comments.push(comment);

        this.editor.view.area.appendChild(comment.el);
        this.editor.trigger('commentcreated', comment);
    }

    deleteComment(comment) {
        this.editor.view.area.removeChild(comment.el);
        this.comments.splice(this.comments.indexOf(comment), 1);

        this.editor.trigger('commentremoved', comment);
    }

    deleteFocusedComment() {
        const focused = this.comments.find(c => c.focused());
        
        if (focused)
            this.deleteComment(focused)
    }

    deleteComments() {
        [...this.comments].map(c => this.deleteComment(c));
    }

    toJSON() {
        return this.comments.map(c => c.toJSON())
    }

    fromJSON(list) {
        this.deleteComments();
        list.map(item => {
            if (item.type === 'frame') {
                this.addFrameComment(item.text, item.position, item.links, item.width, item.height, item.color)
            } else {
                this.addInlineComment(item.text, item.position, item.links);
            }
        });
    }
}
